import { Link } from 'gatsby'
import { Button } from 'nzk-react-components'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
text-align: center;
color: #351778;
padding: 0 30px;
.big-icons-hero--icons {
  display: flex;
  gap: 0.4em;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  justify-content: space-between;
}

.cta {
  margin-top: 60px;
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
}

.title {
  position: relative;
  width: fit-content;
  margin: 0 auto;
}

.icon--wrapper {
  max-width: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2em;

  .icon--text {
    font-weight: bold;
    line-height: 1.2;
  }
}


.icon {
  position: relative;
  width: 80px;
  height: 80px;
  
  .icon--bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }


  .icon--icon {
    position: absolute;
    bottom: 5px;
    left: 0px;
    height: 60px;
    width: 60px;


    > :first-child {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 80%;
      object-fit: bottom left;
    }
  }
}



@media screen and (max-width: 820px) {
  .title {
    max-width: 220px;
  }

  .big-icons-hero--icons {
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
  }

  .icon--wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .icon--text {
    max-width: 140px;
  }
  .icon {
    .icon--icon {
      width: 80px;
      height: 80px;
    }
  }
}
`

export const ParentsV2_BigIconsHero = (props: {
  title: string
  icons: {
    icon: ReactElement
    text: string
  }[]
  cta?: {
    label: string
    url: string
  }
}) => {
  return <Wrapper>
    <div className='title'>
      <h2>{props.title}</h2>
    </div>
    <div className='big-icons-hero--icons'>
      {
        props.icons.map(icon => {
          return <div className='icon--wrapper'>
            <div className='icon'>
              <div className='icon--bg'>
                <img src='/images/parents-v2/white-blob-icon.svg' />
              </div>
              <div className='icon--icon'>{icon.icon}</div>
            </div>
            <div className='icon--text'>{icon.text}</div>
          </div>
        })
      }
    </div>
    <div>
      {props.cta && <div className='cta'>
        <Link to={props.cta.url}>
          <Button theme='primary'>{props.cta.label}</Button>
        </Link>
      </div>}
    </div>
  </Wrapper>
}
